import { updateOrAddColumnOptionState, updateOrAddColumnTemplate, updateOrAddDatapointRequest } from "../../helpers";
import { defaultComparisonMeasureName } from "../../initialState";
import { formatToColumnTypes } from "components/widgets/grid/grid-column-types";
import { CommmonFormatEnum } from "datapoints";
import { VariationFormat, VariationType } from "store/current-dashboard/types";
export const createVariationOfMetric = (format) => {
    let variationProps = { format: VariationFormat.simpleChange, showPrefix: true };
    switch (format) {
        case CommmonFormatEnum.amount:
            variationProps = { format: VariationFormat.percentageOfChange, gainLoss: { gain: 0, loss: 0 }, showPrefix: true, type: VariationType.toLast };
            break;
        case CommmonFormatEnum.multiple:
            variationProps = { format: VariationFormat.simpleChange, gainLoss: { gain: 0, loss: 0 }, showPrefix: true, type: VariationType.toLast };
            break;
        case CommmonFormatEnum.percent:
            variationProps = { format: VariationFormat.simplePercentage, gainLoss: { gain: 0, loss: 0 }, showPrefix: true, type: VariationType.toLast };
            break;
        default:
            break;
    }
    return variationProps;
};
const updateSparklineAndVariation = (action, componentProps, format) => {
    if (componentProps?.variationOfMetric) {
        componentProps.variationOfMetric = createVariationOfMetric(format);
        action.payload.variation = true;
    }
    if (componentProps?.sparkline) {
        action.payload.history = true;
        componentProps.pipelineParameter.datapointsVisitorsReducer = [
            {
                arguments: [
                    "ReferenceDate",
                    "Desc"
                ],
                method: "sortByDatapoint"
            }
        ];
    }
};
export const addOrUpdateMeasureForKpi = (state, action, componentProps) => {
    const format = Object.entries(formatToColumnTypes).find((e) => e[1] === action.payload.type)?.[0];
    componentProps.valueFormat = format;
    updateSparklineAndVariation(action, componentProps, format);
    updateOrAddDatapointRequest(state, action.payload);
    const newColumnOption = updateOrAddColumnOptionState(state, action.payload);
    if (newColumnOption) {
        updateOrAddColumnTemplate(state, newColumnOption);
    }
    const measures = componentProps.pipelineParameter.compositeObjectBuilder.measures;
    if (measures && !measures.includes(action.payload.id)) {
        measures.push(action.payload.id);
    }
    componentProps.pipelineParameter.nodesVisitorsReducer = [
        {
            arguments: [
                "FormattedValue",
                action.payload.id,
                format,
                "kpi"
            ],
            method: "addFormattedValueVisitor"
        }
    ];
    componentProps.pipelineParameter.customVisitorsReducer = [
        {
            arguments: [
                {
                    display: "FormattedValue",
                    label: action.payload.name,
                    name: action.payload.id
                }
            ],
            method: "kpi"
        }
    ];
    componentProps.pipelineParameter.comparisonVisitorsReducer = [
        {
            arguments: [
                {
                    aggregate: action.payload.id,
                    title: action.payload.name
                },
                {
                    aggregate: defaultComparisonMeasureName,
                    title: state.header.metaData?.entityType?.[0]
                }
            ],
            method: "kpi"
        }
    ];
};
